import { useEffect, useState } from 'react'

function detectTouchDevice() {
  return (
    typeof window !== 'undefined' &&
    ('ontouchstart' in window || navigator.maxTouchPoints > 0 || window.matchMedia?.('(pointer: coarse)').matches)
  )
}

export function useIsTouchDevice() {
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  useEffect(() => {
    setIsTouchDevice(detectTouchDevice())
  }, [])

  return isTouchDevice
}

export default useIsTouchDevice
